<template>
    <div class="home">
        <section class="notice-card">
            <span class="notice-icon">!</span>
            <span class="notice-text">{{ webInfo.notice || '本站应用经过安全检测，提供便捷下载服务' }}</span>
        </section>

        <section class="hero-card" v-if="swiperArr.length">
            <a
                v-for="item in swiperArr"
                :key="item.id"
                href="javascript:void(0)"
                class="banner-link"
                @click="goSwiperLink(item)"
            >
                <img :src="item.pic" alt="" class="slide-img">
            </a>
        </section>

        <div class="content-box">
            <main-nav></main-nav>

            <div class="safe-tip">站长实测严格把控所有应用，提供合规下载入口与安全保障</div>

            <home-slide :dataList="hotList"></home-slide>
        </div>
    </div>
</template>

<script>
import HomeSlide from "@/components/Slide.vue"
import MainNav from "@/components/MainNav.vue"

export default {
    components: {
        MainNav,
        HomeSlide
    },
    data() {
        return {
            webInfo: {
                title: "应用导航",
                notice: "本站应用经过安全检测，提供便捷下载服务"
            },
            swiperArr: [],
            hotList: []
        }
    },
    methods: {
        // 网站信息
        async getSet() {
            const { data: res } = await this.$http.get('/set')
            this.webInfo = res.data[0]
        },
        // 轮播
        async getSwiperList() {
            const { data: res } = await this.$http.get('/swiper_list')
            this.swiperArr = res.data
        },
        // 热门推荐
        async getHotList() {
            const { data: classifyRes } = await this.$http.get('/classify')

            const classifyList = Array.isArray(classifyRes.data) ? classifyRes.data : []
            const categoryList = classifyList
                .map((item) => String(item.classify || '').trim())
                .filter(Boolean)

            const responseList = await Promise.all(
                categoryList.map((className) => this.$http.get('/list_class', {
                    params: { class: className }
                }))
            )

            const mergedList = responseList
                .flatMap(({ data }) => Array.isArray(data.data) ? data.data : [])
                .filter((item, index, arr) => arr.findIndex((row) => Number(row.id) === Number(item.id)) === index)

            const hasAnyClicks = mergedList.some((item) => Number(item.num || 0) > 0)
            const fallbackList = mergedList
                .slice()
                .sort(() => Math.random() - 0.5)

            this.hotList = (hasAnyClicks
                ? mergedList.slice().sort((first, second) => Number(second.num || 0) - Number(first.num || 0))
                : fallbackList
            ).slice(0, 36)
        },
        goSwiperLink(item) {
            if (!item || !item.url) return
            const popup = window.open(item.url, '_blank')
            if (!popup) {
                window.location.href = item.url
            }
            this.$http.post('/track_click', {
                target_type: 'swiper',
                target_id: item.id
            }).catch(() => {
                // 统计失败不阻断跳转
            })
        }
    },
    created() {
        this.getSet()
        this.getSwiperList()
        this.getHotList()
    }
}
</script>

<style lang="less" scoped>
.home {
    position: relative;
    z-index: 2;
}

.notice-card {
    display: flex;
    align-items: center;
    gap: .46rem;
    padding: .54rem .62rem;
    border-radius: .8rem;
    border: 1px solid rgba(255, 181, 242, .72);
    background: linear-gradient(128deg, rgba(248, 85, 188, .84), rgba(106, 111, 253, .82));
    box-shadow: var(--a-shadow);
}

.notice-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.3rem;
    height: 1.3rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, .2);
    color: #fff8d4;
    font-weight: 900;
}

.notice-text {
    color: #ffffff;
    font-size: 1.02rem;
    line-height: 1.2;
    font-weight: 800;
}

.hero-card {
    margin-top: .55rem;
    border-radius: .85rem;
    padding: 0;
    border: 1px solid rgba(151, 115, 255, .7);
    background: linear-gradient(180deg, rgba(48, 13, 124, .97), rgba(31, 8, 82, .96));
    box-shadow: var(--a-shadow);
    overflow: hidden;
}

.banner-link {
    width: 100%;
    display: block;
}

.slide-img {
    width: 100%;
    height: auto;
    object-fit: contain;
    object-position: center;
    display: block;
}

.content-box {
    margin-top: .55rem;
    border-radius: .9rem;
    border: 1px solid rgba(110, 77, 218, .7);
    background: linear-gradient(180deg, rgba(42, 11, 109, .98), rgba(29, 8, 82, .98));
    display: grid;
    gap: .9rem;
    padding: .5rem;
}

.safe-tip {
    color: #ffffff;
    font-size: 1.02rem;
    font-weight: 800;
    line-height: 1.35;
    text-align: center;
    padding: .4rem .5rem 0;
}

@media screen and (max-width: 480px) {
    .notice-text {
        font-size: .95rem;
    }
    .safe-tip {
        font-size: .92rem;
    }
}
</style>